import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { Tab } from "./styled";
import { selectWebsiteTheme } from "../../store/slices/website";

const CLTabs = ({ tabs, selected, onChange }) => {
  const { colors } = useSelector(selectWebsiteTheme);
  return (
    <div>
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          selected={tab.value === selected}
          $color={colors[6].color}
          $bColor={colors[6].color}
          $bgColor={colors[6].color}
          onClick={() => onChange(tab)}
        >
          {tab.label}
        </Tab>
      ))}
    </div>
  );
};

CLTabs.propTypes = {
  tabs: PropTypes.arrayOf({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    raw: PropTypes.any,
  }).isRequired,
  selected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CLTabs.defaultProps = {
  disabled: false,
};

export default CLTabs;
